import * as THREE from 'three'
import { Typename, contentConnection } from './typenames'

export const coverFront = 1
export const coverTop = 2
export const coverRight = 3
export const coverBottom = 4
export const coverLeft = 5
export const coverBack = 6

export const adapter = 10

export const cover = { coverFront, coverTop, coverRight, coverBottom, coverLeft, coverBack }

export const enclosure = [
  coverFront,
  coverTop,
  coverRight,
  coverBottom,
  coverLeft,
  coverBack,
  adapter
]

export const printedcircuitboardPlate = 7
export const printedcircuitboardComponentSide = 8
export const printedcircuitboardSolderSide = 9

export const printedcircuitboardAssembly = [
  printedcircuitboardComponentSide,
  printedcircuitboardSolderSide
]
export const printedcircuitboard = [printedcircuitboardPlate, ...printedcircuitboardAssembly]

export const contentGapFront = 21
export const contentGapTop = 22
export const contentGapRight = 23
export const contentGapBottom = 24
export const contentGapLeft = 25
export const contentGapBack = 26

export const contentEdge = [
  contentGapFront,
  contentGapTop,
  contentGapRight,
  contentGapBottom,
  contentGapLeft,
  contentGapBack
]

export const contentGap = {
  contentGapFront,
  contentGapTop,
  contentGapRight,
  contentGapBottom,
  contentGapLeft,
  contentGapBack
}

export const content = [
  ...printedcircuitboard,
  contentGapFront,
  contentGapTop,
  contentGapRight,
  contentGapBottom,
  contentGapLeft,
  contentGapBack
]

export const screws = 27
export const nuts = 28
export const feets = 29
export const fastener = 30

export const accessories = [screws, nuts, feets]

export const front = [coverFront, contentGapFront]
export const top = [coverTop, contentGapTop]
export const right = [coverRight, contentGapRight]
export const bottom = [coverBottom, contentGapBottom]
export const left = [coverLeft, contentGapLeft]
export const back = [coverBack, contentGapBack]

const generateLayers = (...layers: number[]) => {
  const result = new THREE.Layers()
  layers.forEach((layer, index) => result[index === 0 ? 'set' : 'enable'](layer))
  // console.log(result, new THREE.Layers())
  return result
}

export const layersMap: { [key in Typename]?: THREE.Layers } = {
  Cover: generateLayers(coverFront, coverTop, coverRight, coverBottom, coverLeft, coverBack),
  Gap: generateLayers(
    contentGapFront,
    contentGapTop,
    contentGapRight,
    contentGapBottom,
    contentGapLeft,
    contentGapBack
  ),
  ContentEdge: generateLayers(
    contentGapFront,
    contentGapTop,
    contentGapRight,
    contentGapBottom,
    contentGapLeft,
    contentGapBack
  ),
  [contentConnection]: generateLayers(...content)
}
